import React from 'react';

import {
    TextField,
    MenuItem,
} from "@material-ui/core";

import {
    Translate,
    t
} from "src/shared_modules/i18n";

const formOfAdressCodeToI18nValue = (formOfAdress) => {

    switch(formOfAdress) {
        case "1":
            return t("person-labels.foaMr");
        case "2":
            return t("person-labels.foaMs");
        case "3":
            return t("person-labels.foaMx");
        case "4":
            return "-";

        default:
            break;
    }

    return "";
}

const FoaSelect = (props) => {
    return(<TextField
            id="foa-select"
            fullWidth
            select
            required={props.required}
            disabled={props.disabled}
            label={<Translate>person-labels.formOfAdress</Translate>}
            value={props.value}
            error={props.error}
            onChange={props.onChange}
            variant="outlined"
            style={props.style}
            className={props.className}
        >
        <MenuItem value={""}><em><Translate>person-labels.foaChoose</Translate></em></MenuItem>
        <MenuItem value={"4"}> - </MenuItem>
        <MenuItem value={"1"}><Translate>person-labels.foaMr</Translate></MenuItem>
        <MenuItem value={"2"}><Translate>person-labels.foaMs</Translate></MenuItem>
        <MenuItem value={"3"}><Translate>person-labels.foaMx</Translate></MenuItem>
    </TextField>);
}

export default FoaSelect;

export { formOfAdressCodeToI18nValue };
